module.exports = __webpack_public_path__ + "img/THAM_MY.382ed0a3.svg";